// Wrapper Outlook del drawer mail condiviso: applica il context del provider
// Microsoft e calcola il gate provider-specifico (settings.microsoft_sync_mail +
// account Microsoft connesso). Montato in Layout.tsx. Il componente condiviso è
// <MailDrawer>. Speculare a GmailDrawer.
import React, { useEffect } from 'react';
import { useSettingsStore } from '../../lib/stores/settingsStore';
import { useAuth } from '../../lib/auth';
import { useMicrosoftConnected } from '../../lib/microsoft/useMicrosoftConnected';
import { useGmailDrawerStore } from '../../lib/stores/gmailDrawerStore';
import { useOutlookDrawerStore } from '../../lib/stores/outlookDrawerStore';
import { MailProviderContext } from './MailProviderContext';
import { microsoftMailProvider } from './providers';
import { MailDrawer } from './MailDrawer';

export function OutlookDrawer() {
  const { settings } = useSettingsStore();
  const { user } = useAuth();
  const { connected } = useMicrosoftConnected(user?.id);
  const enabled = !!(settings?.microsoft_sync_mail && connected);
  const isOpen = useOutlookDrawerStore((s) => s.isOpen);

  // Mutua esclusione col drawer Gmail (stessa area/z-index e scroll del body).
  useEffect(() => {
    if (isOpen) useGmailDrawerStore.getState().close();
  }, [isOpen]);

  return (
    <MailProviderContext.Provider value={microsoftMailProvider}>
      <MailDrawer enabled={enabled} />
    </MailProviderContext.Provider>
  );
}
